import { createI18n } from 'vue-i18n'

const savedLocale = localStorage.getItem('locale') || 'en-US'

const messages = {
  'zh-CN': {
    nav: {
      home: '首页',
      news: '新闻',
      products: '产品中心',
      contact: '联系我们'
    },
    common: {
      companyLogoAlt: '公司Logo',
      addressLabel: '地址：',
      phoneLabel: '电话：',
      emailLabel: '邮箱：',
      copyright: '版权所有',
      tagline: '专注于提供高品质的产品和服务',
      cancel: '取消'
    },
    productDetail: {
      breadcrumbProducts: '产品中心',
      categoryLabel: '类别:',
      descriptionTitle: '产品描述',
      specsTitle: '技术规格',
      noSpecs: '暂无规格参数',
      tabs: {
        intro: '详细介绍',
        specs: '规格参数'
      },
      inquiryButton: '产品咨询',
      inquiryTitle: '产品咨询',
      inquiry: {
        validationIncomplete: '请填写完整的咨询信息',
        submitSuccess: '您的咨询已提交，我们将尽快与您联系！',
        submitFailed: '提交失败',
        retryLater: '提交失败，请稍后重试'
      }
    },
    home: {
      companyIntro: {
        title: '公司简介',
        content:
          'INNV 是一家创新型消费电子品牌，深耕手机周边及车载智能配件领域二十余年，承袭深厚的技术积淀与前瞻行业洞察，专注打造兼具创新价值与核心竞争力的绿色产品，旗下产品远销全球各地，凭借稳定品质与适配性，收获全球市场广泛认可。'
      },
      stats: {
        year: { unit: '年', desc: '公司成立' },
        people: { unit: '多人', desc: '全球员工' },
        bases: { unit: '家', desc: '生产基地' },
        patents: { unit: '余款', desc: '研发专利' }
      },
      advantages: {
        items: [
          {
            title: '研发创新',
            desc:
              '我们坚持技术驱动战略，拥有近50名工程师团队，为客户和消费者提供尖端产品。'
          },
          {
            title: '全球制造',
            desc:
              '东莞和马来西亚的两家主要工厂已经建立了英唯科技的全球供应制造能力。'
          },
          {
            title: '供应链管理',
            desc:
              '成熟的供应链管理系统和全球制造本地化，帮助客户提升产品成本优势。'
          },
          {
            title: '品质保障',
            desc:
              '智能制造系统实现从产品研发到出货的全生命周期实现全流程追溯。产品平均直通率可达98%以上。'
          },
          {
            title: '客户服务',
            desc:
              '在过去的20年里，英唯科技与全球众多客户建立了稳定的合作关系。我们熟悉国际商业实体的运营实践和适用的国际法律法规，可以根据客户的需求提供专业服务。'
          }
        ]
      },
      footer: {
        contact: '联系我们',
        links: '快速链接'
      }
    },
    news: {
      pageTitle: '新闻中心',
      imageAlt: '新闻图片',
      readMore: '阅读更多',
      authorLabel: '作者：'
    },
    products: {
      pageTitle: '产品中心',
      pageDesc: '我们提供高品质的产品和解决方案，满足您的各种需求',
      category: {
        all: '全部产品'
      },
      viewDetails: '查看详情'
    },
    contact: {
      pageTitle: '联系我们',
      pageDesc: '我们很高兴回答您有关产品的任何问题。请填写下面的表格，我们将尽快与您联系。',
      info: {
        addressTitle: '公司地址',
        phoneTitle: '联系电话',
        emailTitle: '电子邮箱',
        locationTitle: '公司位置'
      },
      form: {
        consultingTitle: '在线咨询',
        productName: '咨询产品',
        productNamePlaceholder: '请输入咨询产品名称',
        name: '您的姓名',
        namePlaceholder: '请输入您的姓名',
        email: '您的邮箱',
        emailPlaceholder: '请输入您的邮箱',
        phone: '您的电话',
        phonePlaceholder: '请输入您的电话',
        message: '咨询内容',
        messagePlaceholder: '请输入您的咨询内容',
        submit: '提交咨询'
      },
      faq: {
        title: '常见问题',
        items: [
          {
            question: '如何联系客服？',
            answer: '您可以通过本页面的联系表单、电子邮件或电话联系我们的客服团队。我们的工作时间是周一至周五，上午9点至下午6点。'
          },
          {
            question: '产品有保修吗？',
            answer: '是的，我们的所有产品都提供标准的一年保修服务。部分高端产品可能提供更长的保修期，具体请参考产品说明或联系客服咨询。'
          },
          {
            question: '如何查询订单状态？',
            answer: '您可以登录您的账户查看订单状态，或者通过订单确认邮件中的订单号联系我们的客服团队查询。'
          },
          {
            question: '是否提供产品定制服务？',
            answer: '是的，我们提供产品定制服务。请通过联系表单或直接联系我们的销售团队，详细说明您的需求，我们会尽快回复您。'
          }
        ]
      },
      footer: {
        contact: '联系我们',
        links: '快速链接'
      }
    }
  },
  'en-US': {
    nav: {
      home: 'Home',
      news: 'News',
      products: 'Products',
      contact: 'Contact'
    },
    common: {
      companyLogoAlt: 'Company Logo',
      addressLabel: 'Address: ',
      phoneLabel: 'Phone: ',
      emailLabel: 'Email: ',
      copyright: 'All rights reserved',
      tagline: 'Committed to high-quality products and services',
      cancel: 'Cancel'
    },
    productDetail: {
      breadcrumbProducts: 'Products',
      categoryLabel: 'Category:',
      descriptionTitle: 'Description',
      specsTitle: 'Specifications',
      noSpecs: 'No specifications available',
      tabs: {
        intro: 'Details',
        specs: 'Specifications'
      },
      inquiryButton: 'Product Inquiry',
      inquiryTitle: 'Product Inquiry',
      inquiry: {
        validationIncomplete: 'Please complete all required fields',
        submitSuccess: 'Your inquiry has been submitted. We will contact you soon!',
        submitFailed: 'Submission failed',
        retryLater: 'Submission failed, please try again later'
      }
    },
    home: {
      companyIntro: {
        title: 'Company Profile',
        content:
          'INNV is an innovative consumer electronics brand that has been deeply involved in the field of mobile phone peripherals and in-car smart accessories for over two decades. Inheriting profound technical expertise and forward-looking industry insights, it focuses on creating green products that combine innovative value and core competitiveness. Its products are exported to various parts of the world and have gained widespread recognition in the global market due to their stable quality and adaptability.'
      },
      stats: {
        year: { unit: 'Year', desc: 'Founded' },
        people: { unit: 'Employees', desc: 'Global Staff' },
        bases: { unit: 'Bases', desc: 'Manufacturing Sites' },
        patents: { unit: 'Patents', desc: 'R&D Patents' }
      },
      advantages: {
        items: [
          {
            title: 'R&D Innovation',
            desc:
              'We adhere to a technology-driven strategy, with a team of nearly 50 engineers, delivering cutting-edge products for customers and consumers.'
          },
          {
            title: 'Global Manufacturing',
            desc:
              "Two major factories in Dongguan and Malaysia have established Innv's manufacturing capabilities to supply globally."
          },
          {
            title: 'Supply Chain Management',
            desc:
              'A mature supply chain system and localized global manufacturing help customers achieve cost advantages.'
          },
          {
            title: 'Quality Assurance',
            desc:
              'Smart manufacturing systems provide full lifecycle traceability from R&D to shipment. Average first-pass yield exceeds 98%.'
          },
          {
            title: 'Customer Service',
            desc:
              'Over the past 20 years, Innv Technology has established stable partnerships with numerous clients worldwide. We are familiar with the operational practices of international business entities and applicable international laws and regulations, and can provide professional services according to the needs of our clients.'
          }
        ]
      },
      footer: {
        contact: 'Contact Us',
        links: 'Quick Links'
      }
    },
    news: {
      pageTitle: 'News Center',
      imageAlt: 'News Image',
      readMore: 'Read More',
      authorLabel: 'Author: '
    },
    products: {
      pageTitle: 'Products',
      pageDesc: 'We provide high-quality products and solutions to meet your needs.',
      category: {
        all: 'All Products'
      },
      viewDetails: 'View Details'
    },
    contact: {
      pageTitle: 'Contact Us',
      pageDesc: 'We’re happy to answer any questions about our products. Please fill out the form below and we’ll get back to you as soon as possible.',
      info: {
        addressTitle: 'Company Address',
        phoneTitle: 'Contact Phone',
        emailTitle: 'Email',
        locationTitle: 'Company Location'
      },
      form: {
        consultingTitle: 'Online Consultation',
        productName: 'Product to Consult',
        productNamePlaceholder: 'Please enter the product name',
        name: 'Your Name',
        namePlaceholder: 'Please enter your name',
        email: 'Your Email',
        emailPlaceholder: 'Please enter your email',
        phone: 'Your Phone',
        phonePlaceholder: 'Please enter your phone number',
        message: 'Message',
        messagePlaceholder: 'Please enter your message',
        submit: 'Submit'
      },
      faq: {
        title: 'Frequently Asked Questions',
        items: [
          {
            question: 'How to contact customer service?',
            answer: 'You can reach our support team via the contact form on this page, email, or phone. Our working hours are Monday to Friday, 9:00 AM to 6:00 PM.'
          },
          {
            question: 'Do products have warranty?',
            answer: 'Yes, all our products come with a standard one-year warranty. Some high-end products may offer longer warranty periods—please refer to product details or contact support.'
          },
          {
            question: 'How to check order status?',
            answer: 'You can log into your account to view the order status or contact our support team with your order number from the confirmation email.'
          },
          {
            question: 'Do you offer product customization?',
            answer: 'Yes, we provide customization services. Please contact our sales team via the form or directly with your detailed requirements, and we’ll respond as soon as possible.'
          }
        ]
      },
      footer: {
        contact: 'Contact Us',
        links: 'Quick Links'
      }
    }
  }
}

export const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'en-US',
  messages
})

export default i18n
